"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals";
export function useReportWebVitalsCustom(reportWebVitalsFn) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== reportWebVitalsFn) {
    t0 = () => {
      onCLS(reportWebVitalsFn, {
        reportSoftNavs: true
      });
      onLCP(reportWebVitalsFn, {
        reportSoftNavs: true
      });
      onINP(reportWebVitalsFn, {
        reportAllChanges: true,
        reportSoftNavs: true
      });
      onFCP(reportWebVitalsFn, {
        reportSoftNavs: true
      });
      onTTFB(reportWebVitalsFn, {
        reportSoftNavs: true
      });
    };
    t1 = [reportWebVitalsFn];
    $[0] = reportWebVitalsFn;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}